module.exports = __webpack_public_path__ + "img/tema-3-5.fe3b61da.png";